export let API = "";
if (process.env.NODE_ENV === "development") {
  API = "https://desktop.siamoption.com";
}

// Set `window.batman` to `true` to complete debug mode
export const debugMode = true;



// WEBPACK FOOTER //
// ./src/components/constants.js